const categoryStructure = {
  'Feeding': [
    'Bottles & Accessories',
    'Breast Pumps & Nursing Supplies',
    'High Chairs & Booster Seats',
    'Bibs & Burp Cloths',
    'Baby Food Makers & Storage',
    'Sippy Cups & Plates',
    'Formula & Baby Food (unused/sealed only)'
  ],
  'Sleeping': [
    'Cribs & Bassinets',
    'Crib Mattresses & Bedding',
    'Sleep Sacks & Swaddles',
    'Baby Monitors',
    'Portable Cribs & Play Yards',
    'Toddler Beds',
    'Night Lights & Sound Machines'
  ],
  'Clothing': [
    'Newborn (0-3 months)',
    'Infant (3-12 months)',
    'Toddler (1-3 years)',
    'Preschooler (3-5 years)',
    'Seasonal Wear (winter coats, swimwear)',
    'Special Occasion Outfits',
    'Shoes & Accessories'
  ],
  'Transportation': [
    'Strollers & Accessories',
    'Car Seats & Boosters',
    'Baby Carriers & Wraps',
    'Diaper Bags',
    'Shopping Cart Covers',
    'Travel Beds & Accessories',
    'Car Seat Adapters & Accessories'
  ],
  'Bathing & Changing': [
    'Baby Bathtubs & Accessories',
    'Changing Tables & Pads',
    'Diaper Pails & Accessories',
    'Potty Training Supplies',
    'Baby Toiletries (unused only)',
    'Bath Toys',
    'Towels & Washcloths'
  ],
  'Play & Learning': [
    'Activity Centers & Jumpers',
    'Play Mats & Gyms',
    'Educational Toys',
    'Stuffed Animals & Comfort Items',
    'Books & Media',
    'Ride-On Toys',
    'Outdoor Play Equipment'
  ],
  'Furniture': [
    'Dressers & Storage',
    'Rocking Chairs & Gliders',
    'Book Shelves',
    'Play Tables & Chairs',
    'Toy Storage',
    'Décor & Wall Art',
    'Safety Gates & Barriers'
  ],
  'Safety & Health': [
    'Baby Proofing Supplies',
    'Humidifiers & Air Purifiers',
    'Thermometers & Health Kits',
    'Safety Gates & Barriers',
    'Cabinet Locks & Outlet Covers',
    'Baby First Aid Kits',
    'Baby-Safe Cleaning Products'
  ],
  'Pregnancy & Maternity': [
    'Maternity Clothing',
    'Pregnancy Pillows',
    'Belly Bands & Support',
    'Prenatal Education Materials',
    'Post-Partum Recovery Items',
    'Maternity Photography Props'
  ],
  'Seasonal & Special Needs': [
    'Holiday-Themed Items',
    'Special Needs Equipment',
    'Adaptive Toys',
    'Specialty Feeding Equipment',
    'Therapy Tools',
    'Sensory Items'
  ]
};

// Flattened list for backwards compatibility if needed
const goods_categories = Object.keys(categoryStructure);

const age_categories = [
    'Newborn',
    '0-6 Months',
    '6-12 Months',
    '1-3 Years',
    '3-5 Years',
    '5-7 Years',
    'All ages'
  ];

  const conditionOptions = [
    'New', 
    'Almost New',
    'Used', 
    'Needs Repair'
  ];

export { goods_categories, categoryStructure, conditionOptions, age_categories};